import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import ProjectRoutesWrapper from '../../project-routes-wrapper/ProjectRoutesWrapper';
import { RouteConstants } from '../../RouteConstants';
import { ContentHeader } from '@app/shared/layout/content-header/ContentHeader';
import ExpandAllOpm from '@app/shared/components/expand-all/ExpandAllOpm';
import { useLocale } from '@app/core/hooks/useLocale';
import HighlightEditableCells from '@app/shared/components/highlight-editable-cells/HighlightEditableCells';
import { ShowHistoricDataToggle } from '@app/shared/components/show-historic-data/ShowHistoricDataToggle';
import { setOpmShowHistoricYears } from '@app/core/store/ui-values-slice';
import CurrencyLabel from '@app/shared/components/currency-label/CurrencyLabel';
import { OpmInputsForm2 } from './OpmInputs';

export const OpmInputsPage = () => {
  const { l } = useLocale();
  const dispatch = useAppDispatch();
  const showHistoricDataColumns = useAppSelector(
    (state) => state.uiValues.userSelections.opmInputs.showHistoricDataColumns
  );
  const opmResults = useAppSelector((state) => state.opmCalculation.calculatedInputs);
  const opmNumberOfResultsHistoricEventDates = Object.keys(
    opmResults?.historicEventDates ?? {}
  ).length;

  const shouldShowHistoricToggle = opmResults && opmNumberOfResultsHistoricEventDates > 0;

  return (
    <ProjectRoutesWrapper.PageLayout
      key={RouteConstants.OpmInputs}
      contentHeader={
        <ContentHeader
          title={l('_OpmInputs')}
          controlOptions={
            <>
              <CurrencyLabel />
              <ExpandAllOpm />
              <HighlightEditableCells />
              <ShowHistoricDataToggle
                checked={showHistoricDataColumns}
                onToggle={(checked) => dispatch(setOpmShowHistoricYears(checked))}
                shouldShow={shouldShowHistoricToggle}
              />
            </>
          }
        />
      }
      pageName={RouteConstants.OpmInputs}>
      <OpmInputsForm2 />
    </ProjectRoutesWrapper.PageLayout>
  );
};

export default OpmInputsPage;
